import { LanguageService } from '@app/core/services/language.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from "@ngx-formly/core";
import { SearchableSelectComponent } from '@app/shared/components/searchable-select/searchable-select.component';
import { Constants } from '@app/core/services/constants';

@Component({
  selector: 'app-formly-field-select',
  templateUrl: './formly-field-select.component.html',
  styleUrls: ['./formly-field-select.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    FormlyModule,
    SearchableSelectComponent
],
})
  export class FormlyFieldSelectComponent extends FormlyFieldAnyComponent {
  public isOpen = false;
  
  constructor(private changeDetectorRef: ChangeDetectorRef,
              private languageService: LanguageService) {
    super();
  }
  
  public getLabel(optionCode: string): string {
    // return this.languageService.instant(`${this.field.props['formName']}.${this.field.key}.OPTIONS.${optionCode}`);
    const opt = (this.field.props['options'] as any[])?.find((o: any) => o.code === optionCode || o.value === optionCode);
    return (opt ? opt.label : optionCode) || optionCode;
  }

  public getOptions(): any[] {
    return (this.field.props['options'] as any[]) || [];
  }

  public shouldShowSearch(): boolean {
    return this.getOptions().length > Constants.maxOptionsForSearchableSelect;
  }

  public onValueChange(event: any): void {
    const value = event.target?.value || event.detail?.value || null;
    this.formControl.setValue(value);
    this.onChange(value);
    this.changeDetectorRef.markForCheck();
  }

  public onSearchValueChange(value: any): void {
    this.formControl.setValue(value);
    this.onChange(value);
    this.changeDetectorRef.markForCheck();
  }

  public onSearchInput(): void {
    this.changeDetectorRef.markForCheck();
  }
}
